import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-catchWeight-accordian.component.html',
  styleUrls: ['./commodity-catchWeight-accordian.component.css']
})
export class  CommodityCatchWeightAccordianComponent extends AbstractFormWidgetComponent {

  public accordionLine1: Array<any> = ['tareWeight', 'avgcaseWeight', 'tolerancepct', 'ioFlag'];
  public accordionLine2: Array<any> = ['lotxiddetailotherLabel1', 'lotxiddetailotherLabel2', 'lotxiddetailotherLabel3'];


  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }


}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-catchWeight-accordian/commodity-catchWeight-accordian.component.ts